import React from 'react';

import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import LandscapeIcon from '@mui/icons-material/Landscape';
import PoolIcon from '@mui/icons-material/Pool';
import HotTubIcon from '@mui/icons-material/HotTub';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import PetsIcon from '@mui/icons-material/Pets';
import LocalLaundryServiceIcon from '@mui/icons-material/LocalLaundryService';
import FlatwareIcon from '@mui/icons-material/Flatware';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import WifiIcon from '@mui/icons-material/Wifi';
import TvIcon from '@mui/icons-material/Tv';
import OutdoorGrillIcon from '@mui/icons-material/OutdoorGrill';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';

export const AmenitiesIcons = {
  beachfront: <BeachAccessIcon />,
  amazing_views: <LandscapeIcon />,
  pool: <PoolIcon />,
  hot_tub: <HotTubIcon />,
  parking: <LocalParkingIcon />,
  pets: <PetsIcon />,
  ac: <AcUnitIcon />,
  heating: <DeviceThermostatIcon />,
  breakfast: <FreeBreakfastIcon />,
  dryer: <LocalLaundryServiceIcon />,
  washer: <LocalLaundryServiceIcon />,
  gym: <FitnessCenterIcon />,
  kitchen: <FlatwareIcon />,
  tv: <TvIcon />,
  wifi: <WifiIcon />,
  bbq_grill: <OutdoorGrillIcon />,
  fireplace: <FireplaceIcon />,
};
